// extracted by mini-css-extract-plugin
module.exports = {"container":"Aj","heading":"Bj","linkBtn":"Cj","disabled":"Dj","linkUppercaseBold":"Ej","copy":"Fj"};